import { Observable } from "rxjs";
import { FieldBase } from "./field-base";

export class DropdownField extends FieldBase<string> {
  controlType = "dropdown";
  label: string;
  placeholder: string;
  multiple: Boolean;
  nested?: Boolean;
  options: Observable<any>;
  // = new Observable<Array<{key: string, value: string}>([]);

  constructor(options: {} = {}) {
    super(options);
    this.placeholder = options["placeholder"];
    this.label = options["label"];
    this.options = options["options"];
    this.nested = options["nested"] ? options["nested"] : false;
    this.multiple = options["multiple"] ? options["multiple"] : false;
  }
}
